import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { goToPage } from '../../HOME/REDUX/actions';
import { selectSkill } from '../REDUX/actions';
import _ from 'lodash';
import { BEGINNER, JUNIOR, SENIOR, GRADUATE } from '../const';
import { SIZE_PAGE } from '../../HOME/const';
import { Background } from '../COMPONENTS/Background';
import BackButton from '../COMPONENTS/BackButton';
import BeginnerIcon from '../ASSETS/skill.beg.png';
import JuniorIcon from '../ASSETS/skill.jun.png';
import SeniorIcon from '../ASSETS/skill.sen.png';
import GraduateIcon from '../ASSETS/skill.grad.png';
import { windowSize } from '../../HOME/utils';
import { selectorClass } from '../logic';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';

class SkillPage extends Component {
  handleSkill = skill => e => {
    this.props.selectSkill(skill);
    this.props.goToPage(SIZE_PAGE);
  };

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  render() {
    const { x, y } = windowSize();
    const cls = selectorClass(x, y);
    const icons = [BeginnerIcon, JuniorIcon, SeniorIcon, GraduateIcon];

    return (
      <div className="page-root">
        <div className={cls} style={{ backgroundImage: Background }}>
          {_.map([BEGINNER, JUNIOR, SENIOR, GRADUATE], (skill, i) => {
            const flow = x < y ? 'column' : 'row';
            return (
              <div
                key={skill}
                className="option triangula-option"
                style={{ gridAutoFlow: flow }}
                onClick={this.handleSkill(skill)}
              >
                <img src={icons[i]} width={60} />
                <div style={{ color: 'white', textShadow: '2px 2px black', margin: '10px 20px' }}>{skill}</div>
              </div>
            );
          })}
        </div>
        <BackButton />
        <HomeButton />
      </div>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  { selectSkill, goToPage }
)(SkillPage);
